import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Search, Car } from "lucide-react";
import { api, formatVRM } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Loading, ErrorState, EmptyState } from "@/components/States";
import { NumberPlate } from "@/components/NumberPlate";

export default function VehiclesList() {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [q, setQ] = useState("");

  const load = async (query = "") => {
    setLoading(true); setError(null);
    try { setVehicles(await api(`/vehicles${query ? `?q=${encodeURIComponent(query)}` : ""}`)); }
    catch (e) { setError(e.message); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  useEffect(() => { const t = setTimeout(() => load(q), 300); return () => clearTimeout(t); }, [q]);

  return (
    <div>
      <PageHeader title="Vehicles" subtitle="Search by VRM, make or model"
        actions={<Link to="/vehicles/new" data-testid="new-vehicle-btn" className="inline-flex items-center gap-2 rounded-lg bg-brand px-4 py-2.5 text-sm font-bold text-white transition-transform hover:scale-105"><Plus className="h-4 w-4" />Add Vehicle</Link>} />

      <div className="relative mb-4">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search VRM, make or model…" data-testid="vehicle-search"
          className="w-full rounded-lg border border-input bg-card py-2.5 pl-10 pr-3 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/20" />
      </div>

      {loading ? <Loading /> : error ? <ErrorState message={error} onRetry={() => load(q)} /> : vehicles.length === 0 ? (
        <EmptyState icon={Car} title="No vehicles found" description={q ? "Try a different search." : "Add a vehicle — look it up instantly by VRM."}
          action={!q && <Link to="/vehicles/new" className="rounded-lg bg-brand px-4 py-2.5 text-sm font-bold text-white">Add Vehicle</Link>} />
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {vehicles.map((v) => (
            <button key={v.id} onClick={() => navigate(`/vehicles/${v.id}`)} data-testid={`vehicle-card-${v.id}`}
              className="flex flex-col gap-3 rounded-xl border border-border bg-card p-4 text-left transition-colors hover:border-brand hover:bg-brand-tertiary">
              <NumberPlate vrm={v.vrm} />
              <div>
                <p className="font-bold text-midnight">{v.make} {v.model}</p>
                <p className="text-xs text-muted-foreground">{[v.year, v.colour, v.fuel_type].filter(Boolean).join(" · ")}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
